import { DataRef } from './DataRef';
import { IAnyStateTreeNode, Instance, OnReferenceInvalidated, getParent, types } from 'mobx-state-tree';
import { ITree } from './Tree';
import { TreeNode } from './TreeNode';

const onInvalidated: OnReferenceInvalidated<IAnyStateTreeNode> = event => {
  if (event.cause !== 'destroy') {
    console.error('TreeEdge: reference invalidated. Will attempt to remove tree from mobx store.', event);
  }
  getParent<ITree>(event.parent as ITreeEdge).remove();
};

export const TreeEdge = types
  .model('TreeEdge', {
    previous: types.reference(TreeNode, {
      onInvalidated,
    }),
    previousKey: types.string,
    next: types.reference(TreeNode, {
      onInvalidated,
    }),
    nextKey: types.string,
    default: types.maybeNull(types.boolean),
    key: types.maybeNull(types.string),
    dataRef: types.maybeNull(DataRef),
  });

export type ITreeEdge = Instance<typeof TreeEdge>;
